<template>
    <span>{{ label }}</span>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { formatDateRange } from "./dateTimeUtils";

    const props = defineProps<{
        startDate: string;
        endDate?: string | null;
        timezone?: string | null;
    }>();

    const label = computed(() => formatDateRange(props.startDate, props.endDate, props.timezone ?? undefined));
</script>
